import { Image, Pressable, View } from 'react-native'
import { Menu } from 'lucide-react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'
import { images } from '../../../assets'

interface AdminMenuHeaderProps {
  isFull: boolean
  onOpen?: () => void
}

export function AdminMenuHeader({ isFull, onOpen }: AdminMenuHeaderProps) {
  const { t } = useTranslation()

  return (
    <View className={`h-24 ${isFull ? 'justify-center' : 'justify-start'}`}>
      {isFull ? (
        <Image
          source={images.logoDark}
          style={{ width: 92, height: 64 }}
          resizeMode="contain"
          accessibilityLabel={t('adminAuth.logoAccessibilityLabel')}
        />
      ) : (
        <Pressable
          onPress={onOpen}
          accessibilityLabel={t('nav.openMenu')}
          accessibilityRole="button"
          className="h-11 w-11 items-center justify-center rounded-md"
        >
          <Menu size={28} color={colors.text.inverse} strokeWidth={2} />
        </Pressable>
      )}
    </View>
  )
}
